import styled from "styled-components";
import { Select } from "@material-ui/core";

const SelectCustom = styled(Select)`
  &&& {
    > div > div {
      display: flex;
      align-items: center;
      > span {
        font-size: 0;
      }
    }
  }
`;

export default SelectCustom;